import BrowserLogger from 'alife-logger';
import { GAME_ARMS_ID } from '@/config/constant';

const NODE_ENV = process.env.NODE_ENV || 'development';

/**
 * 获取时间戳
 * @returns {String} 时间戳
 */
export const getTimeStamp = () => {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  let day = today.getDate();
  day = day < 10 ? '0' + day : day;
  let hour = today.getHours();
  hour = hour < 10 ? '0' + hour : hour;
  const minute = today.getMinutes();
  const sec = today.getSeconds();
  // const timeStamp = year + "" + month + "" + day + "" + hour + "" + minute + "" + sec;
  const timeStamp = `${year}${month}${day}${hour}${minute}${sec}`;
  return timeStamp;
};

/**
 * 获取随机数
 * @returns {String} 时间戳
 */
export const getRandomString = () => {
  return Math.random().toString(36).slice(2);
};

/**
 * 解析ulr上的参数 转成对象
 */
export const analysisParams = (url) => {
  const params = {};
  const paramsString = url.split('?')[1];
  if (!paramsString) {
    return params;
  }
  const str = paramsString.split('&');
  for (let idx = 0; idx < str.length; idx++) {
    const values = str[idx].split('=');
    params[values[0]] = values[1];
  }
  return params;
};

/**
 * 字符替换
 */
const formatString = (string, regStr, reqStr) => {
  const reg = new RegExp(regStr, 'g');
  return string.replace(reg, reqStr);
};

// 处理特殊的样式值
const supplementStyle = (key, val) => {
  if (key === 'background-image' && val !== 'none') {
    return `url(${val})`;
  }
  return val;
};

/**
 * css属性转成行内样式
 */
export const transformStyle = (cssData = {}) => {
  const supportAttrs = [
    'width',
    'height',
    'background_image',
    'margin',
    'top',
    'left',
    'right',
    'bottom',
    'color',
    'font_size',
    'position'
  ];
  const style = supportAttrs.reduce((result, attr) => {
    if (!cssData[attr]) {
      return result;
    }
    const key = formatString(attr, '_', '-');
    const value = supplementStyle(key, cssData[attr]);
    result += `${key}: ${value}; `;
    return result;
  }, '');
  return `${cssData.style || ''}${style}`;
};

/**
 * 获取html上的fontSize
 */
export const getHtmlFontSize = () => {
  const fontSize = document.getElementsByTagName('html')[0].style.fontSize;
  return Number(fontSize.replace(/px/img, ''));
};

/**
 * ARMS 埋点
 */
export const buriedLogger = (gameName, pageName) => {
  const pid = GAME_ARMS_ID[gameName];
  return BrowserLogger.singleton({
    pid,
    appType: 'web',
    disabled: NODE_ENV === 'development',
    environment: NODE_ENV === 'development' ? 'local' : 'prod',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    page: pageName
  });
};

export const thousands = (num) => {
  var str = num.toString();
  var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
  return str.replace(reg, "$1,");
}


// WEBPACK FOOTER //
// ./src/utils/utils.js